import ModuleQuestionnaire from "./ModuleQuestionnaire";

export default ModuleQuestionnaire;
